export class Address {
    constructor(
        public addressLineOne: string,
        public addressLineTwo: string | null,
        public city: string,
        public county: string | null,
        public postCode: string,
        public country: string
    ) { }

    lines(): string {
        return [
            this.addressLineOne,
            this.addressLineTwo,
            this.city,
            this.county,
            this.country,
            this.postCode,
        ]
            .filter((addressLine): addressLine is string => {
                return addressLine !== null
            })
            .join('\n')
    }

    getISO3166CountryCode(): string {
        switch (this.country.toLowerCase()) {
            case 'united kingdom':
            return 'GB';
            case 'united states':
            return 'US';
            case 'ireland':
            return 'IE';
            default:
            return this.country.toUpperCase()
        }
    }
}
